import { Title } from "../ui/Utilities";
import vignoble_img1 from '../../assets/vignoble1.jpg';
import vignoble_img2 from '../../assets/vignoble2.jpg';
import '../../styles/Vineyard.css';
import { AnimatedDiv } from "../ui/Animations";

export const Vignoble = () => {
   const content = [
      {
         title: "La jeune vigne qui grandit",
         paragraph: "Je m'appelle Erwan Tapparel, et j'ai toujours eu les pieds dans les vignes. Après avoir terminé l'école d'œnologie de Changins en 2023, j'ai décidé de donner vie à mon propre domaine viticole, autour de Corin en Valais. En 2024 nous travaillions environ 1 hectare de vignes, avec un respect profond pour la nature et un engagement pour une viticulture durable. 2500 m² m’étaient réservés pour la vinification, le reste étant livré ou ne produisant pas encore. Mon objectif ? Faire grandir le domaine tout en préservant l'authenticité de chaque cépage. En 2025 le domaine s’est agrandit avec un peu moins de 2 hectares travaillés. De nouveaux cépages ont été plantés, comme la rèze ou le cornalin et une majorité du domaine va pouvoir être vinifié. De plus, les raisins vont être accueillis dans un nouveau local de vinification à Sierre dans le quartier de Muraz. "
      },
      {
         title: "L’art du vin, sans artifice",
         paragraph: "Mon engagement pour une viticulture durable se traduit par des pratiques respectueuses de l’environnement, avec des sols enherbés et une intervention minimale sur le vin. Chaque bouteille que je produis est le fruit de ce travail patient et passionné, un hommage à la nature et au terroir. Venez découvrir mes vins, jeunes mais pleins de promesses, qui reflètent une vision moderne du vin."
      },
      {
         title: "Une vision responsable",
         paragraph: "Mon objectif est clair : faire grandir le domaine pas à pas, avec une attention particulière portée à trois cépages blancs et trois cépages rouges qui me tiennent à cœur..."
      },
   ];

   return (
      <div className="vignoble_container">
         <Title title="Le Vignoble"/>
         <AnimatedDiv delay={0.3}>
              <div className="vignoble_grid">
               <div className="vignoble_images">
                  <img src={vignoble_img1} alt="vignoble 1" className="vignoble_img"/>
                  <img src={vignoble_img2} alt="vignoble 2" className="vignoble_img"/>
               </div>
               <div className="vignoble_text_right">
                  <h2 className="text-large">{content[0].title}</h2>
                  <p className="text-medium ">{content[0].paragraph}</p>
                   <h2 className="text-large">{content[1].title}</h2>
                  <p className="text-medium ">{content[1].paragraph}</p>
                      <h2 className="text-large">{content[2].title}</h2>
                  <p className="text-medium ">{content[2].paragraph}</p>
               </div>
            </div>
         </AnimatedDiv>
           {/* Suite du texte sur toute la largeur */}
           
       
      </div>
   );
};